import { VueReCaptcha } from 'vue-recaptcha-v3'

export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.vueApp.use(VueReCaptcha, {
    siteKey: process.env.RECAPTCHA_SITE_KEY,
    loaderOptions: {
      autoHideBadge: true,
      useEnterprise: true,
      explicitRenderParameters: {
        badge: 'bottomright'
      }
    }
  })
})
